import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { CalculatorResultWrapper } from '../../../models/analysis/calculator-result-wrapper';
import { FormGroup } from '@angular/forms';
import { SavePlantResponse } from '../../../models/analysis/save-plant-response';
import {UserRole} from "../../../models/user/user-role.enum";

@Component({
  selector: 'psc-save-power-plant',
  templateUrl: './save-power-plant.component.html',
})
export class SavePowerPlantComponent {

  resultWrapper: CalculatorResultWrapper;

  @Input()
  set calculatorResultWrapper(value: CalculatorResultWrapper) {
    this.resultWrapper = value;
    this.saveDisabled = false;
  }

  get calculatorResultWrapper(): CalculatorResultWrapper {
    return this.resultWrapper;
  }

  @Output() plantSaved: EventEmitter<SavePlantResponse> = new EventEmitter<SavePlantResponse>();

  formGroup: FormGroup;
  saveDisabled: boolean = false;
  showDialog: boolean;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
  ) {
  }


  onSavedPlant(response: SavePlantResponse) {
    this.plantSaved.emit(response);
    this.showDialog = false;
    this.saveDisabled = true;
    this.changeDetectorRef.detectChanges();
  }
    protected readonly UserRole = UserRole;
}
